module.exports = __webpack_public_path__ + "img/dynamic_lukuan.8939168e.png";